import React, { useEffect, useRef, useState } from "react";

const tones = {
  info:    { ring: "ring-blue-300/50",    bg: "bg-blue-600",    text: "text-white" },
  success: { ring: "ring-emerald-300/50", bg: "bg-emerald-600", text: "text-white" },
  warn:    { ring: "ring-amber-300/50",   bg: "bg-amber-500",   text: "text-black" },
  error:   { ring: "ring-red-300/50",     bg: "bg-red-600",     text: "text-white" },
};

export default function ToastHub() {
  const [toasts, setToasts] = useState([]);
  const idRef = useRef(0);

  useEffect(() => {
    const onToast = (e) => {
      const { message, tone = "info", ttl = 2200 } = e.detail || {};
      const id = ++idRef.current;
      setToasts((t) => [...t, { id, message, tone }]);
      setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), ttl);
    };
    window.addEventListener("mudo:toast", onToast);
    return () => window.removeEventListener("mudo:toast", onToast);
  }, []);

  return (
    <div className="fixed bottom-3 right-3 z-[9999] flex flex-col gap-2">
      {toasts.map((t) => {
        const s = tones[t.tone] || tones.info;
        return (
          <div
            key={t.id}
            className={`px-3 py-2 rounded-xl shadow-lg ring-1 ${s.ring} ${s.bg} ${s.text} text-sm`}
          >
            {t.message}
          </div>
        );
      })}
    </div>
  );
}
